/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentAccountSimpleDto } from './paymentAccountSimpleDto';
import { AirtimeCostReportDto } from './airtimeCostReportDto';
import { TransactionSimpleDto } from './transactionSimpleDto';
import { AirtimeFeesDto } from './airtimeFeesDto';


export interface AirtimeDeviceCalculationDto { 
    id?: number;
    insertTs?: string;
    deviceId?: number;
    fees?: AirtimeFeesDto;
    bytes?: number;
    inclusiveBytes?: number;
    startDate?: string;
    endDate?: string;
    currency?: AirtimeDeviceCalculationDto.CurrencyEnum;
    numberOfConnections?: number;
    airtimeCostReport?: AirtimeCostReportDto;
    paymentAccount?: PaymentAccountSimpleDto;
    transaction?: TransactionSimpleDto;
}
export namespace AirtimeDeviceCalculationDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


